import { createGlobalStyle, css } from 'styled-components';

import { resetStyles } from './reset';
import { responsiveFont } from './utils';
import { variables } from './variables';

// stylelint-disable selector-type-no-unknown
export const Styles = createGlobalStyle`
  ${resetStyles}
 
  :root {
    --scale-element: 1;
    --scale-font: 1;

    ${variables.verticalBreakpoints.map(
      ({ height, scale }) => css`
        @media (max-height: ${height}) {
          --scale-element: ${scale};
          --scale-font: ${scale};
        }
      `,
    )}
  }

  html,
  body {
    min-height: 100vh;
    background-color: ${variables.colors.background};
  }

  html {
    -webkit-overflow-scrolling: touch;
    overflow-x: hidden;
    /* always show the vertical scrollbar so that content doesn't jump */

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    box-sizing: border-box;
    overflow-y: hidden; 
    overscroll-behavior: none;
  }

  /* inherited from <html> */
  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  body {
    ${responsiveFont()}
    overscroll-behavior: none;
    position: relative;

    margin: 0;

    font-family: ${variables.font.family};
    line-height: ${variables.font.lineHeight};
    /* iOS on orientation change */
    text-size-adjust: 100%;

    color: ${variables.colors.font};
  }

  img {
    display: block;
    max-width: 100%;
    height: auto;
  }

  /* placeholders */
  input,
  textarea,
  select {
    &::placeholder {
      opacity: 1;
      color: ${variables.colors.placeholder};
    }
  }

  .fade-out {
    opacity: 0;
    animation-name: fadeOutOpacity;
    animation-iteration-count: 1;
    animation-timing-function: ease-in;
    animation-duration: 0.5s;
  }
  
  @keyframes fadeOutOpacity {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  .fade-in {
    opacity: 1;
    animation-name: fadeInOpacity;
    animation-iteration-count: 1;
    animation-timing-function: ease-in;
    animation-duration: 0.5s;
  }
  
  @keyframes fadeInOpacity {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;


